import React from 'react';
import { useSelector } from 'react-redux';

import { Form } from 'ui/components';
import { SkeletonsForm } from 'ui/components/skeleton';

const initialState = {
  note: '',
};

export const FormInput = ({ data, loading, onInputChange }) => {
  const StateForm = useSelector((state) => state?.Form);

  const [{ note }, setState] =
    React.useState(initialState);

  const dummy = Array.from({ length: 4 }, (v, i) => i);

  React.useEffect(() => {
    const input = {
      note,
    };

    onInputChange(input);
  }, [note]);

  React.useEffect(() => {
    if (!data) return;

    setState((prevState) => ({
      ...prevState,
      note: data?.note
    }));
  }, [data])

  return (
    <div className="px-2 px-md-2 pe-md-4">
      {loading ? (
        <div className="row ">
          {dummy?.map((d, i) => (
            <div className="col-md-4" key={i}>
              <SkeletonsForm count={1} />
            </div>
          ))}
        </div>
      ) : (
        <>
          <Form.Textbox
            label="Catatan"
            value={note}
            rows={3}
            onChange={(e) =>
              setState((prevState) => ({
                ...prevState,
                note: e.target.value,
              }))
            }
            error={StateForm?.errors?.note}
          />
        </>
      )}
    </div>
  );
};
